exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-n-8-ts-creations-n-8-ts-creations-tsx": () => import("./../../../src/pages/n8ts-creations/N8tsCreations.tsx" /* webpackChunkName: "component---src-pages-n-8-ts-creations-n-8-ts-creations-tsx" */)
}

